import { HrCustomLine, ReportMainContainer, ReportTitleContainer } from './styles'
import { ReportData } from './Children/ReportData'
import { NavLink, useLocation } from 'react-router-dom'
import { Nav, navLinkStyled, notStyledNav, styledNav } from 'pages/Configurations/styles'
import { ROUTES_NAMES } from 'constants/name.routes'
import ReportEexport from 'pages/Report/ExportReport'
import { useState } from 'react';
import { LeftSideFilters } from './Children/LeftSideFilters'

export default function Report() {
  const { pathname } = useLocation()
  const [tooltipAlert, setTooltipAlert] = useState<boolean>()
  const [dashboards, setDashboards] = useState<string[]>([])

  return (
    <>
      <ReportMainContainer>
        <ReportTitleContainer>
          <Nav>
            <NavLink
              to={ROUTES_NAMES.reports}
              className={({ isActive }) =>
                `${navLinkStyled} ${isActive ? styledNav : ''}`
              }
            >
              Relatório geral
            </NavLink>
            < NavLink
              to={ROUTES_NAMES.exportReport}
              className={({ isActive }) =>
                `${navLinkStyled} ${isActive ? styledNav : notStyledNav}`
              }
            >
              Exportar relatório
            </NavLink>
          </Nav>
        </ReportTitleContainer>

        <HrCustomLine />
        
        {pathname === ROUTES_NAMES.reports ? (
          <div data-testid="test-relatorios-tab" className='flex'>
            <LeftSideFilters dashboards={dashboards} setDashboards={setDashboards}/>
            <ReportData setTooltipAlert={setTooltipAlert} dashboards={dashboards}/>
          </div>
        ) : (
          <div data-testid="test-relatorios-export-tab" className='flex'>
            <LeftSideFilters setTooltipAlert={setTooltipAlert} dashboards={dashboards} setDashboards={setDashboards}/>
            <ReportEexport  setTooltipAlert={setTooltipAlert} tooltipAlert={tooltipAlert} />
          </div>
        )}
      </ReportMainContainer >
    </>
  )
}
